import { addToChainAfter, createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { chain, DispatchCompleteLoadSession } from "@insite/client-framework/Store/Context/Handlers/LoadSession";

// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

// trying to reference a handler not in the chain will result in a warning and the chain will not be modified
addToChainAfter(
    chain,
    DispatchCompleteLoadSession,
    props => {
        props.dispatch({
            type: "ShowPrice/Toggle", canSeePrice: props.apiResult?.properties?.canSeePrice === "true",
        } as any);   

    },
);